/** The host-session issuer's authorize request (backend routes/oidc.ts). */
const AUTHORIZE = "/api/oidc/authorize?";

/** `returnTo` if it is the issuer's authorize request on this origin, else null. */
export function issuerReturn(returnTo: string | null): string | null {
  return returnTo?.startsWith(AUTHORIZE) ? returnTo : null;
}
